// Generated by CoffeeScript 2.7.0
import "./application_init.js";
import $ from "jquery";

TryItParent.namespace('common');

TryItParent.common = {
  displayToggle: function(selector, target) {
    return $(selector).on('click', function() {
      $(target).toggle();
    });
  },
  selectMonth: function(selector) {
    return $(selector).on('change', function() {
      location.href = '/billing/' + this.value + '/';
    });
  }
};
